export default __webpack_public_path__ + "static/media/anti-spam-security-icon.525e4f91.svg";